<template>
    <li>
        <label>
            <span class="checkmark unchecked" v-if="!task.completion_time" v-on:click="toggleCompletion(task.event_id, new Date())"></span>
            <span :style="cssVars" class="checkmark checked" v-if="task.completion_time" v-on:click="toggleCompletion(task.event_id, new Date())"></span>
            <span class="navigation">{{ task.name }}</span>
            <div class="task-description">
                {{ task.description }}
            </div>
        </label>
    </li>
</template>

<script>

    export default {
        props: ['task'],
        data: function () {
            return {
            }
        },
        computed: {
            cssVars() {
                return {
                    '--check-url': `url(${process.env.MIX_BASE_URL}/storage/media/pcs/parks/icon-check.svg)`
                }
            }
        },
        methods: {
            toggleCompletion(event, date){
                // console.log("do something here")
            },
            navigateToComponent: function(task){
                window.location.href = task.task_type;
            }
        }

    }
</script>

<style scoped lang="scss">
    @import "../../../sass/_variables.scss";

    li {
        margin-top: 10px;
        margin-bottom: 12px;
    }

    label {
        display: block;
        position: relative;
        padding-left: 28px;
        margin-top: 11px;
        margin-bottom: 12px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    label input {
        display: none;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 4px;
        left: 0;
        height: 16px;
        width: 16px;
        background-color: #eee;
        border: 1px solid $sim-heading;
    }

    .navigation {
        font-family: "Raleway", sans-serif;
    }
    .task-description {
        font-size: 14px;
        color: grey;
    }

    /* When the checkbox is checked, add a blue background */
    .checked {
        background-color: #A7BBC2;
        background: var(--check-url) no-repeat center center;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .checked ~ .checkmark:after {
        display: block;
    }
</style>